import React from 'react';
import { Router, Route, browserHistory, IndexRedirect, Redirect } from 'react-router';

import redirectRoute from '@evdy/web-core/dist/components/redirectRoute';

import App from './components/App';

import EmailStep from './components/EmailStep';
import BirthdateStep from './components/BirthdateStep';
import ZipcodeStep from './components/ZipcodeStep';
import PhoneStep from './components/PhoneStep';
import ConfirmProvider from './components/ConfirmProvider';
import PackageSummary from './components/PackageSummary';
import GreatChoice from './components/GreatChoice';
import PreparingPackage from './components/PreparingPackage';
import EFuneralPurchase from './components/EFuneralPurchase';
import PurchaseConfirmation from './components/PurchaseConfirmation';
import PostMessage from './components/PostMessage';
import PackageRequest from './components/PackageRequest';
import SelectPackage from './components/SelectPackage';
import SelectProvider from './components/SelectProvider';
import YourPrice from './components/YourPrice';
import PurchaseSummary from './components/PurchaseSummary';
import ThankYou from './components/ThankYou';
import YourFuneralPackage from './components/YourFuneralPackage';
import GetMyEstimate from './components/GetMyEstimate';
import ResumePurchase from './components/ResumePurchase';
import ExtraDetails from './components/ExtraDetails';
import CreateAccount from './components/CreateAccount';

const Routes = (store, history) => {
  return (
    <Router history={history || browserHistory}>
      <Route path="/" component={App}>
        <IndexRedirect to="/404" />
        {/* <Route path="/b/package-request" component={PackageRequest} />
        <Route path="/b/great-choice" component={GreatChoice} />
        <Route path="/b/preparing-package" component={PreparingPackage} />
        <Route path="/b/e-funeral-purchase" component={EFuneralPurchase} />
        <Route path="/b/purchase-confirmation" component={PurchaseConfirmation} />
        <Route path="/b/post-message-test" component={PostMessage} />
        <Route path="/b/email" component={EmailStep} />
        <Route path="/b/dob" component={BirthdateStep} />
        <Route path="/b/city" component={ZipcodeStep} />
        <Route path="/b/provider" component={ConfirmProvider} />
        <Route path="/b/phone" component={PhoneStep} />
        <Route path="/b/pricedisplay" component={PackageSummary} />
        <Route path="/c/get-my-estimate/results" component={PackageSummary} />
        <Route path="get-my-price" component={GetMyEstimate} />
        <Route path="/get-my-price/select-package" component={SelectPackage} />
        <Route path="/get-my-price/select-provider" component={SelectProvider} />
        <Route path="/your-price" component={YourPrice} />
        <Route path="/order/summary" component={PurchaseSummary} />
        <Route path="/thank-you" component={ThankYou} />
        <Route path="/your-funeral-package" component={YourFuneralPackage} />
        <Route path="/resume/:userId" component={ResumePurchase} />
        <Route path="/get-my-price/keys" component={ExtraDetails} />
        <Route path="/get-my-price/create-account" component={CreateAccount} />
        <Redirect from="get-my-estimate" to="get-my-price" />
        <Redirect from="get-my-price/results" to="get-my-price" />
        <Redirect from="get-my-price/select-plan" to="get-my-price" />
        <Redirect from="order/details" to="get-my-price" /> */}
        {redirectRoute()}
      </Route>
    </Router>
  );
};

export default Routes;
